import { useMemo } from "react";
const useArrayMapMemo = (items, map) => {
  const mapped = useMemo(() => items.map(map), [map, ...items]);
  return useMemo(() => mapped, mapped);
};
export {
  useArrayMapMemo
};
//# sourceMappingURL=useArrayMapMemo.js.map
